// @ts-nocheck
import { formatUsd } from './lib/format';

/** @param {any} row */
export function aiMessageCaption(row) {
  if (!row || typeof row !== 'object') return '';
  const provider = String(row.provider || '').trim();
  const model = String(row.model || '').trim();
  const hasCost = row.cost_usd != null && row.cost_usd !== '';
  if (!provider && !model && !hasCost) return '';
  const who = [provider, model].filter(Boolean).join(' / ');
  const cost = hasCost ? formatUsd(row.cost_usd) : '';
  return [who, cost].filter(Boolean).join(' · ');
}
